// src/config/axios.config.js
import axios from 'axios';
import config from './api.config';

const axiosInstance = axios.create({
    baseURL: config.apiUrl,
    timeout: 120000,
    headers: { 'Content-Type': 'application/json' },
});

// Request Interceptor - Add Token
axiosInstance.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('adminToken');
        if (!token) token = localStorage.getItem('token');
        
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        
        if (config.data instanceof FormData) {
            delete config.headers['Content-Type'];
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor - Handle Token Expiry
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            try {
                let refreshToken = localStorage.getItem('adminRefreshToken');
                let isAdmin = true;
                
                if (!refreshToken) {
                    refreshToken = localStorage.getItem('refreshToken');
                    isAdmin = false;
                }
                
                const response = await axios.post(`${config.apiUrl}/auth/refresh-token`, {
                    refreshToken
                });
                
                const { token } = response.data;
                
                if (isAdmin) {
                    localStorage.setItem('adminToken', token);
                } else {
                    localStorage.setItem('token', token);
                }
                
                originalRequest.headers.Authorization = `Bearer ${token}`;
                return axiosInstance(originalRequest);
                
            } catch (refreshError) {
                const isAdminRoute = window.location.pathname.startsWith('/admin') || 
                                    window.location.pathname.startsWith('/seller');
                
                if (isAdminRoute) {
                    localStorage.removeItem('adminToken');
                    localStorage.removeItem('adminRefreshToken');
                    localStorage.removeItem('adminData');
                    window.location.href = '/admin/login';
                } else {
                    localStorage.removeItem('token');
                    localStorage.removeItem('refreshToken');
                    window.location.href = '/login';
                }
            }
        }
        return Promise.reject(error);
    }
);

export default axiosInstance;